import { render, staticRenderFns } from "./selectbutton.vue?vue&type=template&id=05021830&scoped=true&"
import script from "./selectbutton.vue?vue&type=script&lang=js&"
export * from "./selectbutton.vue?vue&type=script&lang=js&"
import style0 from "./selectbutton.vue?vue&type=style&index=0&id=05021830&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05021830",
  null
  
)

export default component.exports